module.exports = __webpack_public_path__ + "img/p1.81c8fea8.png";